import { render, staticRenderFns } from "./allocation.vue?vue&type=template&id=da91a41a&scoped=true&"
import script from "./allocation.js?vue&type=script&lang=js&"
export * from "./allocation.js?vue&type=script&lang=js&"
import style0 from "./allocation.vue?vue&type=style&index=0&id=da91a41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da91a41a",
  null
  
)

export default component.exports